import api from "./Api";

class GeneroSpedService {
  GetGeneroSped(payload) {
    return api.get("/v1/generoSped/" + payload).then((response) => {
      return response.data;
    });
  }

  PostGeneroSped(payload) {
    return api.post("/v1/generoSped/", payload).then((response) => {
      return response.data;
    });
  }

  PutGeneroSped(payload) {
    return api.put("/v1/generoSped/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteGeneroSped(payload) {
    return api.delete("/v1/generoSped/" + payload).then((response) => {
      return response.data;
    });
  }

  GetGeneroSpedOData(payload) {
    return api.get("/OData/GeneroSped" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new GeneroSpedService();
